import { EldmlTransform } from "./EldmlTransform";
import $ from "jquery";
import { iconForMimeType, isImageMimeType } from "./MimeTypeHelper";

interface FileValue {
  filePath?: string;
  key: string;
  mimeType: string;
  source: string;
}

export class FileTransform extends EldmlTransform {
  apply() {
    this.selector.find("file").each((_, element) => {
      // aktualny tag
      const file = $(element);

      // pobieramy atrybuty
      let value = file.attr("field-value");

      // parsujemy wartość
      let jsonObject: [FileValue] | undefined = value
        ? JSON.parse(value)
        : undefined;

      if (!jsonObject) {
        return;
      }

      // tworzymy kontener
      const container = $("<div></div>");
      container.addClass('eldml-file-container')

      // dla plików
      for (const fileData of jsonObject) {
        const fileContainer = $("<div></div>");
        if (fileData.filePath && isImageMimeType(fileData.mimeType)) {
          const imageElement = document.createElement("img");
          imageElement.className = "eldml-file-image"
          imageElement.src = fileData.filePath;
          fileContainer.append(imageElement);
        } else {
          const iconElement = document.createElement("div");
          iconElement.classList.add(iconForMimeType(fileData.mimeType))
          iconElement.classList.add("eldml-file-icon")
          fileContainer.append(iconElement);
        }

        fileContainer.on("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.transformer.onFileClick(fileData.key, fileData.source);
        });

        container.append(fileContainer);
      }

      // dodajemy kontener
      file.append(container);
    });
  }
}
